import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ShopifyError } from 'src/app/shop';

@Component({
    selector: 'app-alert',
    templateUrl: './alert.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AlertComponent {
  @Input() status: string = '';
  @Input() title?: string = '';
  @Input() message?: string;
  @Input() showIcon?: boolean = false;
  @Input() icon?: string;
  @Input() showDefaultError?: boolean = false;
  @Input() errors: ShopifyError[] = [];
  @Input() prefix: string = 'alert';
  @Input() shopifyCodePrefix: 'CustomerErrorCode' | 'CartErrorCode' | 'CheckoutErrorCode' = 'CustomerErrorCode';
  @Input() useFallbackErrormessagesFromShopify: boolean = true;
  @Input() useErrormessagesFromShopify: boolean = false;

  get alertIcon() {
    switch (this.status) {
      case 'type--error':
        return 'alert-cross-sm';

      case 'type--succes':
        return null;

      case 'type--warning':
        return 'alert-triangle-sm';

      case 'type--danger':
        return 'alert-cross-sm';

      default:
        return null;
    }
  }

  constructor() {}
}
